// REMIX HMR BEGIN
import * as __hmr__ from "remix:hmr";
if (import.meta) {
import.meta.hot = __hmr__.createHotContext(
//@ts-expect-error
"app/components/paragraph/index.ts"
);
import.meta.hot.lastModified = "1732036225888.2578";
}
// REMIX HMR END

export { default as ParagraphCard } from './ParagraphCard';
export { default as ParagraphCardGroup } from './ParagraphCardGroup';
export { default as ParagraphCodeBlock } from './ParagraphCodeBlock';
export { default as ParagraphHero } from './ParagraphHero';
export { default as ParagraphHeroImage } from './ParagraphHeroImage';
export { default as ParagraphImage } from './ParagraphImage';
export { default as ParagraphStaticComponent } from './ParagraphStaticComponent';
export { default as ParagraphText } from './ParagraphText';
export { default as ParagraphViewReference } from './ParagraphViewReference';
export { default  as ParagraphResponsiveImage} from './ParagraphResponsiveImage'
export { default  as ParagraphTestimonial } from './ParagraphTestimonial'
export { default  as ParagraphStaticForm, isSupportedForm } from './ParagraphStaticForm'